<template>
  <div class="theme-selector">
    <h1 class="title">Select Your Theme</h1>
    <p class="subtitle">Click theme icon to select</p>
    
    <div class="main-content">
      <div class="illustration-container clearfix">
          <div class="text-left">
              <div class="central-part red-font">"central part of</div> 
              <div class="family red-font">FAMILY"</div>
              <div class="exceptional red-font">"Exceptional</div>
              <div class="visual-stimuli red-font">associated visual stimuli"</div>
              <div class="miss-you red-font">I MISS YOU</div>
              <div class="theme-dots">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot selected"></span>
                <span class="dot"></span>
                <span class="dot"></span>
            </div>
          </div>
              
          <div class="illustration">
            <!-- SVG illustration -->
          </div>
          
          <div class="molecular-structure">
            <!-- Empty div for molecular structure -->
          </div>
      </div>

      

      <div class="memorial-wrapper">
        <div class="memorial-subtitle">For a pet that has passed away</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'ProfileCardDisplayer',
    data() {
      return {}
    }
}
</script>

<style scoped>
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    .theme-selector {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
        font-family: 'Roboto', sans-serif;
        max-width: 1400px;
        margin: 0 auto;
    }
    .title {
        font-size: 36px;
        margin-bottom: 5px;
        font-weight: 600;
        color: #333;
    }
    .subtitle {
        font-size: 16px;
        margin-bottom: 30px;
        color: #555;
    }
    .main-content {
        position: relative;
        width: 100%;
        padding: 30px;
        padding-bottom: 60px;
        background-color: white;
    }
    @font-face {
        font-family: 'radley';
        src: url(@/assets/font/Radley-Regular.ttf);
    }
    @font-face {
        font-family: 'kage';
        src: url(@/assets/font/KAGE_DEMO_FONT-Black.otf);
    }
    @font-face{
        font-family: 'anton';
        src: url(@/assets/font/Anton-Regular.ttf);
    }
    @font-face{
        font-family: 'intro-script';
        src: url(@/assets/font/IntroScriptDemo-Medium.otf);
    }
    @font-face {
        font-family: 'Horizon';
        src: url(@/assets/font/Horizon.otf);
    }
    @font-face{
        font-family: 'lustria';
        src: url(@/assets/font/Lustria-Regular.ttf);
    }
    .red-font{
        color: #ba554c;
    }
    body {
        font-family: 'Roboto', sans-serif;
        background-color: #f8f9fa;
    }
    .central-part{
        font-size: 22px;
        font-family: radley, serif;
        margin-bottom: 0;
    }
    .exceptional {
        font-size: 26px;
        font-family: kage, serif;
        margin-bottom: 3px;
    }
    .family{
        font-size: 50px;
        font-weight: 700;
        font-family: Anton, Anton-Regular;
        line-height: 1;
        margin-bottom: 15px;
        margin-top: -5px;
    }
    .visual-stimuli{
        font-family: intro-script, serif;
        font-size: 22px;
        margin-bottom: 10px;
    }
    .miss-you{
        font-family: Horizon, sans-serif;
        font-size: 36px;
        font-weight: 700;
        margin-bottom: 20px;
    }
    .text-left {
        float: left;
        width: 33.33%;
        position: relative;
        padding: 20px;
    }
    .illustration {
        float: left;
        width: 33.33%;
        height: 350px;
        background-image: url('@/assets/images/memorial-theme.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        position: relative;
    }
    /* Better person/dog illustration based on the image */
    .illustration::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        /* background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 500'%3E%3Cpath d='M400,150 C380,180 370,250 370,350 C370,400 380,450 400,480' stroke='%23a68a64' stroke-width='2' fill='none'/%3E%3Cpath d='M400,150 C450,100 550,100 600,150 C650,200 650,300 600,350' stroke='%23a68a64' stroke-width='2' fill='none'/%3E%3Cpath d='M400,150 C420,130 450,120 480,130 C510,140 520,160 520,200' stroke='%23a68a64' stroke-width='2' fill='none'/%3E%3Cpath d='M450,300 C470,280 500,280 530,300 C560,320 570,350 570,400 C570,450 550,480 530,490' stroke='%23a68a64' stroke-width='2' fill='none'/%3E%3Cpath d='M400,480 L600,480' stroke='%23a68a64' stroke-width='2' fill='none'/%3E%3Cpath d='M500,200 C530,180 560,190 570,220 C580,250 560,270 530,260' stroke='%23a68a64' stroke-width='2' fill='none'/%3E%3C/svg%3E"); */
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        opacity: 0.8;
    }
    
    /* Add dotted connection line between person and dog */
    .illustration::after {
        content: '';
        position: absolute;
        top: 230px;
        left: 50%;
        width: 150px;
        height: 2px;
        background-image: repeating-linear-gradient(to right, #a68a64, #a68a64 5px, transparent 5px, transparent 10px);
        transform: translateX(-50%);
    }
    
    .molecular-structure {
        float: left;
        width: 33.33%;
        height: 350px;
        background-image: url('@/assets/journey/oxytocin@2x.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        position: relative;
        opacity: 0.2;
    }
    /* Molecular structure graphic */
    .molecular-structure::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 500 500'%3E%3Cpath d='M100,100 L150,150 L200,100 L250,150 L300,100 L350,150 L400,100' stroke='%23cccccc' stroke-width='2' fill='none'/%3E%3Cpath d='M100,200 L150,250 L200,200 L250,250 L300,200 L350,250 L400,200' stroke='%23cccccc' stroke-width='2' fill='none'/%3E%3Cpath d='M100,300 L150,350 L200,300 L250,350 L300,300 L350,350 L400,300' stroke='%23cccccc' stroke-width='2' fill='none'/%3E%3Ccircle cx='150' cy='150' r='8' fill='%23cccccc'/%3E%3Ccircle cx='250' cy='150' r='8' fill='%23cccccc'/%3E%3Ccircle cx='350' cy='150' r='8' fill='%23cccccc'/%3E%3Ccircle cx='150' cy='250' r='8' fill='%23cccccc'/%3E%3Ccircle cx='250' cy='250' r='8' fill='%23cccccc'/%3E%3Ccircle cx='350' cy='250' r='8' fill='%23cccccc'/%3E%3Ccircle cx='150' cy='350' r='8' fill='%23cccccc'/%3E%3Ccircle cx='250' cy='350' r='8' fill='%23cccccc'/%3E%3Ccircle cx='350' cy='350' r='8' fill='%23cccccc'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        opacity: 0.5;
    }
    
    .clearfix:after {
        content: '';
        height: 0;
        display: block;
        clear: both;
    }
    .illustration-container {
        margin-bottom: 30px;
        border-bottom: 1px solid #f0f0f0;
        padding-bottom: 40px;
        position: relative;
    }
    .theme-dots {
        text-align: center;
        margin: 20px 0;
    }
    .dot {
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        margin: 0 6px;
        cursor: pointer;
        opacity: 0.9;
        box-shadow: 0 0 2px rgba(0,0,0,0.2);
    }
    .dot:nth-child(1) {
        background-color: #e8e8e8;
    }
    .dot:nth-child(2) {
        background-color: #e8e0cf;
    }
    .dot:nth-child(3) {
        background-color: #f8b9b4;
    }
    .dot:nth-child(4) {
        background-color: #e8d8c4;
    }
    .dot:nth-child(5) {
        background-color: #d8d8d8;
    }
    .dot.selected {
        border: 2px solid #999;
        transform: scale(1.1);
    }
    .memorial-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 30px;
    }
    .memorial-subtitle {
        text-align: center;
        font-style: italic;
        font-size: 19px;
        color: #333;
        font-family: 'radley', serif;
    }
</style>